<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div>
          <a-input class="inp ml24" placeholder="请输入公告关键字" v-model:value="query.title"></a-input>
        </div>

        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
      </div>
      <div class="search-r">
        <a-button class="ml30" @click="add" type="primary">+ 新建</a-button>
        <a-button class="ml30" type="primary" @click="router.push('/home/enterprise')"><i class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button>
      </div>
    </div>

    <!-- 公告列表 -->
    <a-card class="content-card" :bordered="false" >
      <template #title>
        <div class="announcement-header">
          <span>最新政策公告</span>
        </div>
      </template>
      <div class="announcement-list">
        <div v-for="item in dataSource" :key="item.id" class="announcement-item">
          <div class="announcement-title">{{ item.title }}</div>
          <div class="announcement-meta">
            <span>{{ formatDate(item.publishDate) }}</span>
            <a-button size="small" type="link" @click="viewAnnouncement(item.id)">查看详情</a-button>
          </div>
          <div class="announcement-content">{{ item.content }}</div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <a-pagination
            v-model:current="pagination.current"
            v-model:pageSize="pagination.pageSize"
            :pageSizeOptions="pagination.pageSizeOptions"
            :total="pagination.total"
            showSizeChanger
            @change="pageChange"
            @showSizeChange="pageSizeChange"
        />
      </div>
    </a-card>

    <!-- 新增公告弹框组件 -->
    <add-modal
        :visible="addModalVisible"
        @cancel="handleCancel"
        @success="handleAddSuccess"
        width="600px"
    />
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import { message } from 'ant-design-vue'
import { getPagesByCondition } from "@/api/announcement/index.js";
import useUserStore from '@/store/modules/user'
import AddModal from './components/AddModal.vue';

const router = useRouter();
const store = useUserStore();

const addModalVisible = ref(false);

let dataSource = ref([]);
let query = reactive({
  title: '',
  status: '1'
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 5, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
});

// 格式化日期
const formatDate = (dateString) =>{
  if (!dateString) return '';
  // 根据实际日期格式进行调整
  return dateString;
}

// 查看详情
const viewAnnouncement = (id) => {
  router.push({ path: '/announcement/detail', query: { id: id } });
}

// 打开新增公告弹窗
const add = () => {
  addModalVisible.value = true;
}

const handleCancel = () => {
  addModalVisible.value = false;
}

// 处理新增成功
const handleAddSuccess = () => {
  addModalVisible.value = false;
  getData();
}

const pageChange = (page, pageSize) => {
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const search = () => {
  pagination.current = 1
  getData();
};

const reset = () => {
  query.title = "";
  pagination.current = 1
  getData()
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query, deptId: store.deptId },
  };
  getPagesByCondition(data).then((res) => {
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total;
    }
  });
};

onMounted(async () => {
  getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 25vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

.main {
  padding: 20px;
  min-height: calc(100vh - 70px);
  background-color: #ffffff;
}

.content-card {
  margin-top: 12px;
  width: 100%;
}

.content-card .ant-card-body {
  padding-left: 12px;
  padding-right: 12px;
}

.announcement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.announcement-list {
  padding-left: 24px;
  padding-right: 24px;
}

.announcement-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.announcement-title {
  font-size: 16px;
  font-weight: 500;
  color: #1d2129;
  margin-bottom: 4px;
  line-height: 1.5;
}

.announcement-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  color: #545c64;
}

.announcement-content {
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  padding-right: 16px;
}

a {
  color: #1E8EF2;
}
</style>